import { useEffect } from 'react'

export function Seo({ title, description, image, canonical }: { title: string; description?: string; image?: string; canonical?: string }) {
  useEffect(() => {
    document.title = title
    const setMeta = (selector: string, attr: 'name'|'property', value?: string) => {
      if (!value) return
      let element = document.head.querySelector<HTMLMetaElement>(selector)
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute(attr, selector.match(/"(.+)"/)?.[1] || '')
        document.head.appendChild(element)
      }
      element.content = value
    }
    setMeta('meta[name="description"]', 'name', description)
    setMeta('meta[property="og:title"]', 'property', title)
    setMeta('meta[property="og:description"]', 'property', description)
    setMeta('meta[property="og:image"]', 'property', image)
    if (canonical) {
      let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
      if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link) }
      link.href = canonical
    }
  }, [title, description, image, canonical])
  return null
}
